// src/ConsoleForm.js
import './asset/App.css';
import Header from './component/Header';
import React, { useState, useEffect, useRef } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DataGrid, GridToolbar, zhTW } from '@mui/x-data-grid';

function ConsoleForm() {

  const [rows, setRows] = useState([]); // 使用状态来存储数据
  const [archiveOpen, setArchiveOpen] = React.useState(false);//作廢popup
  const [archiveForm, setArchiveForm] = React.useState({}); //作廢表單

  //批量上傳
  const navigate = useNavigate();

  //作廢popup
  const handleArchiveClickOpen = (data) => {
    setArchiveForm(data);
    setArchiveOpen(true);
  };

  const handleArchiveClose = (check) => {
    if(check){
      console.log(archiveForm);
      fetch('https://macct.tw/api/form/archive', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
        },
        body: JSON.stringify(archiveForm)
      })
      .then(response => response.json())
      .then(data => {
        // 根据返回的数据判断是否已登录
        console.log("get result:", data);
        if (data.success) {
          alert("勞報單作廢成功");
          setArchiveOpen(false);
          window.location.reload();
        } else {
          alert("勞報單作廢失敗 \n \n", data);
          setArchiveOpen(false);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }else{
      setArchiveForm("");
      setArchiveOpen(false);
    }

  };

  const columnsNew = [
    { field: 'createdAt', headerName: '創立日期', width: 150 },
    { field: 'id', headerName: '編號', width: 150 },
    { field: 'category', headerName: '申報類別', width: 150 },
    { field: 'service', headerName: '勞務內容', width: 150 },
    { field: 'name', headerName: '姓名', width: 100 },
    {
      field: 'price',
      headerName: '金額',
      width: 80,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        return `$${params.value.toLocaleString('en-US')}`;
      }
    },
    { field: 'download', 
      headerName: '紙本下載', 
      width: 120,
      renderCell: (params) => {
        return(      
          <Button variant="contained" color="primary" onClick={handlePaperPrint}>
            下載
          </Button>
      )} 
    },
    { field: 'status', 
      headerName: '狀態', 
      width: 150,
      valueGetter: (params) => {
        let status = "";
        switch (params.row.status) {
          case 'pending':
            status = "待確認";
            break;
          case 'done':
            status = "已完成";
            break;
          case 'archive':
            status = "已作廢";
            break;
          case 'draft':
            status = "待對方填寫";
            break;
        }
        return status;
      }
    },
  
    { field: 'option', 
      headerName: '選項', 
      width: 100,
      renderCell: (params) => {
        // you will find row info in params
        return(      
          <Button component={Link} to={`/form?id=${params.row.id}`} variant="contained" color="primary">
            查看
          </Button>
      )} 
    },
    { field: 'archive', 
      headerName: '作廢', 
      width: 100,
      renderCell: (params) => {
        console.log(params.row);
        const data = {id:params.row.id, name:params.row.name, price:params.row.price};
        if(params.row.status != "pending" && params.row.status != "draft"){
          return "";
        }
        return (
          <Button variant="contained" color="error" onClick={() => handleArchiveClickOpen(data)}>
            作廢
          </Button>
        ); 
      } 
    }
  ];

  //勞報單資料
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    const userId = queryParameters.get("id");
    
    if(!userId){
        alert("連結錯誤");
        return "";
    }

    // 发送请求到 http://masteraccounting.tw:3001/api/login
    fetch(`https://macct.tw/api/form/userForms?id=${userId}`, {
      method: 'GET',
      credentials: 'include' // 保持与后端会话的状态
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            const rowData = data.forms.map(form => createData(form.createdAt, form.id, form.category, form.service,form.fullName, form.price, "", form.status, "", ""));
            setRows(rowData); // 将数据设置到状态中
        }else{
            alert("資料錯誤");
        }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }, []); // 使用空数组作为依赖，确保 useEffect 只执行一次

  const handlePaperPrint = () => {
    alert("功能製作中, 待完整版推出");
  };

  //row data to pretty form
  function createData(createdAt, id, category, service, name, price, download, status, option, archive) {
    return { createdAt, id, category, service, name, price, download, status, option, archive };
  }

  return (
    <div className="App">
      <Header />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '90%', margin: 'auto' }}>
        <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
          勞務報酬單列表
        </Typography>
        <div>
        </div>
      </div>
       
      <Paper sx={{ width: '90%', overflow: 'hidden', m:"auto" }}>
      <div style={{ height: 900, width: '100%' }}>
        <DataGrid 
          rows={rows} 
          columns={columnsNew} 
          disableColumnSelector
          slots={{ toolbar: GridToolbar }}
          slotProps={{toolbar: {showQuickFilter: true}}} 
          localeText={zhTW.components.MuiDataGrid.defaultProps.localeText}
        />
      </div>
      </Paper>
      <Dialog
        open={archiveOpen}
        onClose={handleArchiveClose}
        aria-labelledby="archive-dialog-title"
        aria-describedby="archive-dialog-description"
      >
        <DialogTitle id="archive-dialog-title">
          {"確定要作廢此勞務報酬單?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="archive-dialog-description">
            <div>編號：{archiveForm.id}</div>
            <div>姓名：{archiveForm.name}</div>
            <div>金額：{archiveForm.price}</div>
            <div>注意：一旦作廢將無法回復。</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleArchiveClose(false)}>取消</Button>
          <Button onClick={() => handleArchiveClose(true)} autoFocus>確認</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ConsoleForm;